import classNames from '@utils/classnames';

import { CheckboxWithLabel } from '../checkbox/CheckboxWithLabel';

export interface IInlineSelectItem {
  key: string;
  name: string;
}

export interface IInlineSelectProps {
  items: IInlineSelectItem[];
  selectedItems: IInlineSelectItem[];
  onSelect: (selectedItems: IInlineSelectItem[]) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isOptional?: boolean;
  onBlur?: () => void;
  className?: string;
  /** Adds a checkbox above the list that (de)selects every item; shown when there is more than one item. */
  selectAllLabel?: string;
}

export const InlineSelect: React.FC<IInlineSelectProps> = (props) => {
  const { items, selectedItems, onSelect, isDisabled, className, selectAllLabel } = props;
  const selectedCount = items.filter((item) => selectedItems.some((v) => v.key === item.key)).length;

  return (
    <div className={classNames('flex flex-col items-start gap-2', className)}>
      {selectAllLabel && items.length > 1 && (
        <div className="w-full border-b border-border pb-2">
          <CheckboxWithLabel
            labelText={selectAllLabel}
            isDisabled={isDisabled}
            isChecked={selectedCount === items.length}
            isIndeterminate={selectedCount > 0 && selectedCount < items.length}
            onChange={(isChecked) => onSelect(isChecked ? items : [])}
          />
        </div>
      )}
      {items.map((item) => {
        return (
          <CheckboxWithLabel
            key={item.key}
            labelText={item.name}
            isDisabled={isDisabled}
            isChecked={!!selectedItems.find((v) => v.key === item.key)}
            onChange={(isChecked) => {
              const hasValue = selectedItems.find((v) => v.key === item.key);
              if (isChecked && !hasValue) {
                onSelect([...selectedItems, item]);
              } else if (!isChecked) {
                onSelect(selectedItems.filter((v) => v.key !== item.key));
              }
            }}
          />
        );
      })}
    </div>
  );
};
